import { GetProps } from "antd";

import { ModalStyled } from "./CustomModal.styles";

type TCustomModalProps = GetProps<typeof ModalStyled>;

function CustomModal(props: TCustomModalProps) {
  return <ModalStyled {...props} />;
}

export default CustomModal;
